import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedSeed = {
    id: 1,
    network: { id: 1, name: 'mon réseau' },
    orgId: 1,
    since: '1597851960',
    until: null
};
const mock = {
    get: mockedRequester(mockedSeed, 'orgNetworks.get'),
    getAll: mockedRequester([mockedSeed], 'orgNetworks.getAll'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedSeed]), 'orgNetworks.getMany'),
    getPage: mockedRequester(mockedPaginatedResponse([mockedSeed]), 'orgNetworks.getPage'),
    leave: mockedRequester(undefined, 'orgNetworks.leave')
};
export default mock;
